var _g, _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTriangle = function SvgTriangle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -290.65)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6 284.65h36v36H-6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 302.65,
    r: 18
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14l-4-4h8z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "189a0a9ee5ed3ea5ec2eee1fa2f2e15f.svg";
export { ForwardRef as ReactComponent };